
const ConsejosSection = () => {
  const consejos = [
    {
      titulo: 'Prepara Fotos del Vehículo',
      descripcion: 'Aunque no es obligatorio, enviar fotos del coche nos ayuda a hacer una valoración más precisa. Incluye imágenes de los daños, del interior y de la documentación.',
      icon: 'ri-camera-fill',
    },
    {
      titulo: 'Ten la Documentación Lista',
      descripcion: 'Asegúrate de tener el DNI, permiso de circulación y ficha técnica accesibles. Esto agilizará el proceso de venta y la recogida del vehículo en Gavá.',
      icon: 'ri-file-list-3-fill',
    },
    {
      titulo: 'Vacía el Coche de Objetos Personales',
      descripcion: 'Antes de la recogida, revisa el interior del vehículo y retira todos tus objetos personales. No olvides revisar la guantera y el maletero.',
      icon: 'ri-inbox-unarchive-fill',
    },
    {
      titulo: 'Cancela el Seguro Después de la Venta',
      descripcion: 'Una vez vendido el coche y tramitada la baja, contacta con tu aseguradora para cancelar la póliza y evitar pagos innecesarios.',
      icon: 'ri-shield-cross-fill',
    },
    {
      titulo: 'Pregunta Todas tus Dudas',
      descripcion: 'Si tienes cualquier pregunta sobre el proceso, los documentos o el pago, no dudes en consultarnos. Estamos aquí para ayudarte en todo momento.',
      icon: 'ri-question-answer-fill',
    },
    {
      titulo: 'Compara Ofertas si lo Necesitas',
      descripcion: 'Te animamos a comparar nuestra oferta con otras del mercado. Estamos seguros de que nuestros precios son competitivos y nuestro servicio, el mejor de Gavá.',
      icon: 'ri-scales-3-fill',
    },
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Consejos para Vender tu Coche en Gavá
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Recomendaciones útiles para que el proceso de venta de tu coche siniestrado o averiado sea aún más rápido y sencillo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {consejos.map((consejo, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${consejo.icon} text-emerald-600 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>{consejo.titulo}</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">{consejo.descripcion}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConsejosSection;
